export interface MetricDefinition {
  key: keyof UsageMetrics;
  label: string;
  description?: string;
  defaultValue: number;
  format?: 'number' | 'currency' | 'percentage';
}

export const USAGE_METRICS_CONFIG: MetricDefinition[] = [
  {
    key: 'totalInvitedClients',
    label: 'Invited (Pending Intake)',
    description: 'Clients invited who have not yet completed their intake form',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'totalClientsWithSurveysCompleted',
    label: 'Surveys Completed',
    description: 'Clients who have completed their intake surveys',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'totalClientsWithApplicationsStarted',
    label: 'Applications Started',
    description: 'Clients who have started policy applications',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'totalActiveQuotedPremium',
    label: 'Premiums Quoted',
    description: 'Total projected premiums across all policies',
    defaultValue: 0,
    format: 'currency',
  },
  {
    key: 'totalPoliciesQuoted',
    label: 'Policies Quoted',
    description: 'Total number of policy quotes generated',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'totalClientsWithFinancePlans',
    label: 'LTC Plans Created',
    description: 'Clients who have created LTC plans',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'totalApplicationsSubmitted',
    label: 'Applications Submitted',
    description: 'Applications that have been formally submitted to Carriers/BGAs',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'advisorActivityScore',
    label: 'Advisor Activity Score',
    description:
      'Total count of all advisor actions and interactions in the platform over the last 30 days (includes page views, clicks, feature usage, and other tracked events)',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'totalAdvisorLogins',
    label: 'Advisor Logins',
    description: 'Number of unique days the advisor logged in',
    defaultValue: 0,
    format: 'number',
  },
  {
    key: 'advisorOnboardingPercentage',
    label: 'Onboarding Progress',
    description: 'Percentage of onboarding steps completed',
    defaultValue: 0,
    format: 'percentage',
  },
];

// Helper to create empty metrics object
export function createEmptyMetrics(): UsageMetrics {
  return USAGE_METRICS_CONFIG.reduce((acc, metric) => {
    acc[metric.key] = metric.defaultValue;
    return acc;
  }, {} as UsageMetrics);
}

// Helper for generic aggregation
export function aggregateMetrics(advisorMetrics: UsageMetrics[]): UsageMetrics {
  return USAGE_METRICS_CONFIG.reduce((acc, metric) => {
    acc[metric.key] = advisorMetrics.reduce((sum, advisor) => sum + advisor[metric.key], 0);
    return acc;
  }, {} as UsageMetrics);
}
